import { render, staticRenderFns } from "./manageIndex.vue?vue&type=template&id=26283aa2&scoped=true&"
import script from "./manageIndex.vue?vue&type=script&lang=js&"
export * from "./manageIndex.vue?vue&type=script&lang=js&"
import style0 from "./manageIndex.vue?vue&type=style&index=0&id=26283aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26283aa2",
  null
  
)

export default component.exports